import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["helperText", "twStyle", "orientation"],
    _excluded2 = ["options", "onChange", "testId", "isFullWidth", "orientation"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { memo, useMemo } from 'react';
import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react';
import { SkeletonLoading, TextInput } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RadioGroup = /*#__PURE__*/memo(function (props) {
  var helperText = props.helperText,
      twStyle = props.twStyle,
      orientation = props.orientation,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsx(RadioGroupWrapper, {
      orientation: orientation,
      twStyle: twStyle,
      children: /*#__PURE__*/_jsx(RadioComponent, _objectSpread({
        orientation: orientation
      }, rest))
    })
  });
});
export default RadioGroup;
var RadioComponent = /*#__PURE__*/memo(function (props) {
  var options = props.options,
      onChange = props.onChange,
      testId = props.testId,
      isFullWidth = props.isFullWidth,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'vertical' : _props$orientation,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/_jsx(HeadlessRadioGroup, _objectSpread(_objectSpread({
    className: orientation === 'horizontal' ? "flex flex-row ".concat(isFullWidth ? 'justify-between flex-nowrap gap-1' : 'flex-wrap gap-3') : 'flex flex-col gap-3',
    as: "ul",
    "data-cy": testId,
    onChange: onChange
  }, rest), {}, {
    children: options ? options.map(function (option, index) {
      return /*#__PURE__*/_jsx(Radio, _objectSpread({
        orientation: orientation,
        option: option,
        index: index,
        isFullWidth: isFullWidth
      }, rest), option.id + index);
    }) : /*#__PURE__*/_jsx(SkeletonLoading, {
      variant: "text"
    })
  }));
});
export var Radio = function Radio(_ref) {
  var option = _ref.option,
      index = _ref.index,
      value = _ref.value,
      borderless = _ref.borderless,
      showVerticalLineBelow = _ref.showVerticalLineBelow,
      id = _ref.id,
      inlineTextInputProps = _ref.inlineTextInputProps,
      testId = _ref.testId,
      orientation = _ref.orientation,
      customOptionStyle = _ref.customOptionStyle,
      hideIndicator = _ref.hideIndicator,
      isFullWidth = _ref.isFullWidth,
      _ref$returnKey = _ref.returnKey,
      returnKey = _ref$returnKey === void 0 ? 'id' : _ref$returnKey;
  var returnKeyWithType = returnKey;
  var optionValue = option[returnKeyWithType];
  var checked = useMemo(function () {
    return value === optionValue;
  }, [optionValue, value]);
  var returnId = useMemo(function () {
    return returnKeyWithType && optionValue ? "".concat(optionValue === null || optionValue === void 0 ? void 0 : optionValue.toString(), "-").concat(id) : option.id;
  }, [id, option.id, optionValue, returnKeyWithType]);
  var hasInput = useMemo(function () {
    return value === 'other' && option.id === 'other';
  }, [option.id, value]);
  var Icon = option.Icon;
  var otherOptionInput = useMemo(function () {
    if (inlineTextInputProps && hasInput) return /*#__PURE__*/_jsx(TextInput, _objectSpread({
      type: "text",
      name: "other"
    }, inlineTextInputProps));else return null;
  }, [hasInput, inlineTextInputProps]);
  return /*#__PURE__*/_jsx(HeadlessRadioGroup.Option, {
    "data-cy": testId || "".concat(option.id, "-").concat(id),
    onKeyDown: function onKeyDown(e) {
      if (value === 'other') e.stopPropagation();
    },
    value: optionValue,
    id: returnId,
    as: "li",
    className: "w-fit ".concat(isFullWidth ? 'flex-1' : ''),
    disabled: option.disabled,
    children: function children(_ref2) {
      var active = _ref2.active,
          disabled = _ref2.disabled;
      return /*#__PURE__*/_jsxs(StyledRadioOption, {
        id: "radiogroup-StyledOption-".concat(option.label),
        showVerticalLineBelow: showVerticalLineBelow,
        borderless: borderless,
        active: active,
        checked: checked,
        hasInput: hasInput,
        orientation: orientation,
        disabled: disabled,
        customOptionStyle: customOptionStyle,
        colorStyles: value ? undefined : option.colorStyles,
        children: [hideIndicator ? null : /*#__PURE__*/_jsxs(IconWrapper, {
          borderless: borderless,
          children: [Icon ? /*#__PURE__*/_jsx(Icon, {
            className: "h-4 w-4 min-h-[4px] min-w-[4px] relative z-10"
          }) : /*#__PURE__*/_jsx(SelectIcon, {
            checked: checked,
            disabled: disabled,
            borderless: borderless,
            children: checked && (!disabled || disabled && borderless) && /*#__PURE__*/_jsx(StyledIconDot, {
              disabled: disabled
            })
          }), borderless && !disabled ? /*#__PURE__*/_jsx(StyledRadioHoverEl, {}) : null]
        }), /*#__PURE__*/_jsxs(_StyledDiv2, {
          children: [/*#__PURE__*/_jsx(HeadlessRadioGroup.Label, {
            id: "radiogroup-label-".concat(option.label),
            className: "font-medium text-base cursor-pointer leading-4 text-center",
            children: option.label
          }), otherOptionInput]
        })]
      });
    }
  }, option.id + index);
};

var RadioGroupWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "radio-group__RadioGroupWrapper",
  componentId: "sc-1edryfo-0"
})(["", " ", " ", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "width": "100%",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "maxHeight": "20rem",
    "overflowY": "auto"
  }
}, function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation === 'horizontal' ? {
    "maxWidth": "100%"
  } : {};
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle;
});

var StyledRadioOption = /*#__PURE__*/_styled.div.attrs({
  className: 'group'
}).withConfig({
  displayName: "radio-group__StyledRadioOption",
  componentId: "sc-1edryfo-1"
})(["", " ", " ", " ", " ", ";", ";", " ", " ", ""], {
  ":focus-visible": {
    "outlineWidth": "4px",
    "outlineColor": "#e88a99"
  }
}, {
  "display": "flex",
  "height": "3rem !important",
  "maxWidth": "320px",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.75rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem"
  }
}, function (_ref5) {
  var colorStyles = _ref5.colorStyles,
      checked = _ref5.checked;
  return colorStyles ? colorStyles : checked ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(72 36 133 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
    }
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
    }
  };
}, function (_ref6) {
  var borderless = _ref6.borderless;
  return borderless ? {
    "gap": "0px",
    "borderStyle": "none",
    "backgroundColor": "inherit",
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))",
    ":hover": {
      "backgroundColor": "inherit"
    }
  } : {};
}, function (_ref7) {
  var showVerticalLineBelow = _ref7.showVerticalLineBelow;
  return showVerticalLineBelow ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
    "paddingLeft": "0px",
    "paddingRight": "0px"
  } : {};
}, function (_ref8) {
  var hasInput = _ref8.hasInput;
  return hasInput ? {
    "alignItems": "flex-start"
  } : {};
}, function (_ref9) {
  var orientation = _ref9.orientation;
  return orientation === 'horizontal' ? {
    "minWidth": "fit-content",
    "justifyContent": "center"
  } : {};
}, function (_ref10) {
  var disabled = _ref10.disabled,
      borderless = _ref10.borderless;
  return disabled && !borderless ? {
    "pointerEvents": "none",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  } : disabled && borderless ? {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  } : {};
}, function (_ref11) {
  var customOptionStyle = _ref11.customOptionStyle;
  return customOptionStyle;
});

var SelectIcon = /*#__PURE__*/_styled.span.withConfig({
  displayName: "radio-group__SelectIcon",
  componentId: "sc-1edryfo-2"
})(["", " ", " ", " ", " ", ""], {
  "position": "relative",
  "zIndex": "10",
  "display": "grid",
  "height": "1rem !important",
  "minHeight": "16px",
  "width": "1rem !important",
  "minWidth": "16px",
  "placeItems": "center",
  "borderRadius": "9999px",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))"
}, function (_ref12) {
  var checked = _ref12.checked,
      disabled = _ref12.disabled;
  return checked && !disabled && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(72 36 133 / var(--tw-border-opacity))"
  };
}, function (_ref13) {
  var disabled = _ref13.disabled,
      checked = _ref13.checked,
      borderless = _ref13.borderless;
  return disabled && checked && !borderless ? {
    "borderWidth": "4px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(133 133 145 / var(--tw-border-opacity))"
  } : {};
}, function (_ref14) {
  var borderless = _ref14.borderless;
  return borderless ? {
    ".group:hover &": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(72 36 133 / var(--tw-border-opacity))"
    }
  } : {};
}, function (_ref15) {
  var disabled = _ref15.disabled,
      borderless = _ref15.borderless,
      checked = _ref15.checked;
  return disabled && borderless && checked ? {
    "backgroundColor": "inherit"
  } : disabled && borderless ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  } : {};
});

var StyledIconDot = /*#__PURE__*/_styled.span.withConfig({
  displayName: "radio-group__StyledIconDot",
  componentId: "sc-1edryfo-3"
})(["", " ", ""], {
  "height": "0.5rem !important",
  "minHeight": "8px",
  "width": "0.5rem !important",
  "minWidth": "8px",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(72 36 133 / var(--tw-bg-opacity))"
}, function (_ref16) {
  var disabled = _ref16.disabled;
  return disabled ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(133 133 145 / var(--tw-bg-opacity))"
  } : {};
});

var IconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "radio-group__IconWrapper",
  componentId: "sc-1edryfo-4"
})(["", " ", ""], {
  "position": "relative",
  "display": "grid",
  "placeItems": "center"
}, function (_ref17) {
  var borderless = _ref17.borderless;
  return borderless ? {
    "height": "2.5rem",
    "minHeight": "40px",
    "width": "2.5rem",
    "minWidth": "40px",
    ".group:hover &": {
      "--tw-text-opacity": "1",
      "color": "rgb(72 36 133 / var(--tw-text-opacity))"
    }
  } : {};
});

export var StyledRadioHoverEl = /*#__PURE__*/_styled.span.withConfig({
  displayName: "radio-group__StyledRadioHoverEl",
  componentId: "sc-1edryfo-5"
})(["", ""], {
  "position": "absolute",
  "display": "none",
  "height": "2.5rem",
  "minHeight": "40px",
  "width": "2.5rem",
  "minWidth": "40px",
  "placeItems": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))",
  ".group:hover &": {
    "display": "grid"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "radio-group___StyledDiv",
  componentId: "sc-1edryfo-6"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "1.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "radio-group___StyledDiv2",
  componentId: "sc-1edryfo-7"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem"
});